import { useTranslation } from "react-i18next";

import type { TabsProps } from "antd";
import { Spin, TableColumnsType, Tabs } from "antd";
import { useEffect, useState } from "react";
import { CustomTable } from "../../../../components";
import CustomGiftPoint from "../../../../components/CustomGiftPoint";
import { useGetGiftPointRatio } from "../../../../hooks/ShopCart/cart.hooks";
import {
  useGetGiftPoint,
  useGetGiftPointRecord,
} from "../../../../hooks/UserCenter/usercenter.hooks";
import styles from "./style.module.scss";

const GiftPoint = ({ nowTab }: { nowTab: string }) => {
  const [tableData, setTableData] = useState<any>([]);
  const [tabType, setTabType] = useState<any>("0");
  const [ratio, setRatio] = useState<any>("0");
  const { data: giftPointRatio } = useGetGiftPointRatio({});
  const { data: giftPoint } = useGetGiftPoint({});
  const { t } = useTranslation();

  const {
    data,
    refetch,
    isRefetching,
    isLoading: isLoadingRecord,
  } = useGetGiftPointRecord({ type: tabType }, {});

  const onChange = (key: string) => {
    setTabType(key);
  };

  const items: TabsProps["items"] = [
    {
      key: "0",
      label: t("giftpoint.type1"),
    },
    {
      key: "1",
      label: t("giftpoint.type2"),
    },
    {
      key: "2",
      label: t("giftpoint.type3"),
    },
  ];

  const renderDate = (date: any) => {
    if (date) {
      const dateFormat = date?.split("-");
      if (dateFormat[0] === "9999") {
        return <div>{t("normal.neverExpire")}</div>;
      } else {
        return <div>{date}</div>;
      }
    }
  };

  const columns: TableColumnsType<any> = [
    {
      title: t("giftpoint.receive.date"),
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
    },
    {
      title: t("normal.receipt"),
      dataIndex: "order_number",
      key: "order_number",
      // align: "center",
      render: (value, record) => {
        return (
          <>
            <div>{t("giftpoint.record.orderText1")}</div>
            <span style={{ color: "blue" }} key="order_number">
              {record.order_number}
            </span>
          </>
        );
      },
    },
    {
      title: t("normal.giftpoint"),
      dataIndex: "receive_point",
      key: "receive_point",
      align: "center",
      render: (value, record) => {
        return <span>+{record.receive_point}</span>;
      },
    },
    {
      title: t("normal.due.date"),
      dataIndex: "expired_time",
      key: "expired_time",
      align: "center",
      render: (_, record) => {
        return <span>{renderDate(record.expired_time)}</span>;
      },
    },
    {
      title: t("giftpoint.balance"),
      dataIndex: "used_point",
      key: "used_point",
      align: "center",
      render: (value, record) => {
        return (
          <>
            <span>{record.receive_point - record.used_point}</span>
          </>
        );
      },
    },
  ];

  const usedColumns: TableColumnsType<any> = [
    {
      title: t("giftpoint.useDate"),
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
    },
    {
      title: t("normal.receipt"),
      dataIndex: "order_number",
      key: "order_number",
      align: "center",
      render: (value, record) => {
        return (
          <>
            <span>{t("giftpoint.record.orderText1")}</span>
            <span style={{ color: "blue" }} key="order_number">
              {record.order_number}
            </span>
          </>
        );
      },
    },
    {
      title: t("normal.giftpoint"),
      dataIndex: "gift_point_used_point",
      key: "gift_point_used_point",
      align: "center",
      render: (value, record) => {
        return <span>-{record.gift_point_used_point}</span>;
      },
    },
  ];
  const expiredColumns: TableColumnsType<any> = [
    {
      title: t("giftpoint.expiredDate"),
      dataIndex: "expired_time",
      key: "expired_time",
      align: "center",
    },
    {
      title: t("normal.receipt"),
      dataIndex: "order_number",
      key: "order_number",
      align: "center",
      render: (value, record) => {
        return (
          <>
            <span>{t("giftpoint.record.orderText3")}</span>
          </>
        );
      },
    },
    {
      title: t("normal.giftpoint"),
      dataIndex: "gift_point",
      key: "receive_point",
      align: "center",
      render: (value, record) => {
        return (
          <>
            <span>-{record.receive_point - record.used_point}</span>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (data) {
      setTableData(
        data.data.map((i: any) => {
          return i;
        })
      );
    }
  }, [data]);
  useEffect(() => {
    if (tabType) {
      refetch();
    }
  }, [tabType, tableData]);

  useEffect(() => {
    if (nowTab === "userinfo") {
      setTableData([]);
    }
  }, [nowTab]);

  useEffect(() => {
    if (giftPointRatio) {
      const GET_RATE = giftPointRatio?.ratio?.split(":");
      setRatio(GET_RATE[1]);
    }
  }, [giftPointRatio]);

  return (
    <div className={styles.orderInquiry}>
      <div className={styles.title}>{t("orderIquiry.giftpoint.record")}</div>
      <div className={styles.content}>
        <div className={styles.goldArea}>
          <div className={styles.goldLabel}>
            {t("orderIquiry.giftpoint.balance")}
          </div>
          <CustomGiftPoint number={Number(giftPoint)} />
          {t("giftpoint.approximate", {
            money: Math.trunc(Number(giftPoint) / ratio),
          })}
        </div>
        <Tabs
          defaultActiveKey="0"
          items={items}
          onChange={onChange}
          size="large"
        />
        {tabType === "0" ? (
          isLoadingRecord || isRefetching ? (
            <div style={{ textAlign: "center", padding: "16px 0" }}>
              <Spin />
            </div>
          ) : (
            <CustomTable
              tableProps={{
                columns: columns,
                dataSource: tableData,
                scroll: { x: 1200 },
                rowKey: "id",
              }}
              hasMoreProps={{
                showInifineScroll: tableData?.length > 0,
              }}
            />
          )
        ) : tabType === "1" ? (
          isRefetching ? (
            <div style={{ textAlign: "center", padding: "16px 0" }}>
              <Spin />
            </div>
          ) : (
            <CustomTable
              tableProps={{
                columns: usedColumns,
                dataSource: tableData,
                // scroll: { x: 1200 },
                rowKey: "id",
              }}
              hasMoreProps={{
                showInifineScroll: tableData?.length > 0,
              }}
            />
          )
        ) : isRefetching ? (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <Spin />
          </div>
        ) : (
          <CustomTable
            tableProps={{
              columns: expiredColumns,
              dataSource: tableData,
              // scroll: { x: 1200 },
              rowKey: "id",
            }}
            hasMoreProps={{
              showInifineScroll: tableData?.length > 0,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default GiftPoint;
